import React from "react";

import { useSelector } from "react-redux";

import ActivitiesButtonTitle from "../../components/ActivitiesButtonTitle";

import ActivitiesArticleBoxByCategory from "../../components/client/ActivitiesArticleBoxByCategory";

const ABOUT_POST_SLUGS = [
  "qua-trinh-hinh-thanh-va-phat-trien",
  "thu-ngo-cua-chu-tich-hoi",
  "co-cau-to-chuc",
  "dieu-le-hoi",
  "quy-che-hoat-dong-cua-hoi",
  "quy-che-hoat-dong-ban-chap-hanh",
  "quy-che-chi-tieu-noi-bo",
];

function Activities() {
  const posts = useSelector((state) =>
    state.posts?.posts?.filter(
      (post) =>
        post.type != "notification" &&
        post.status === "published" &&
        post.category?.slug !== "chinh-sach" &&
        !ABOUT_POST_SLUGS.includes(post.slug) &&
        post.slug !== "dieu-khoan",
    ),
  );

  const groupPostsByCategory = (posts) => {
    return posts.reduce((acc, post) => {
      const categoryName = post.category?.name || "Chưa phân loại";

      if (!acc[categoryName]) {
        acc[categoryName] = [];
      }

      acc[categoryName].push(post);

      return acc;
    }, {});
  };

  const groupedPosts = groupPostsByCategory(posts);

  return (
    <div>
      <div className="grid grid-cols-12 gap-4 mt-3 mb-2">
        <div className="col-span-12">
          {Object.keys(groupedPosts).map((categoryName) => (
            <div key={categoryName} className="mb-4">
              <h2 className=" font-bold mb-4">
                <ActivitiesButtonTitle title={categoryName} />
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {groupedPosts[categoryName].map((article) => (
                  <ActivitiesArticleBoxByCategory
                    key={article.id}
                    article={article}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Activities;